module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('top-bar'), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38818052"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue
// module id = 448
// module chunks = 1